export const border = {
  radius: {
    sm: 3 as const,
    md: 8 as const,
    lg: 12 as const,
  },
};
